import React from 'react';

import { useConversionTable } from 'hooks';

import { useCXIStartup } from '../useCXIStartup';

import * as Styled from './StyledCXIStartupSummaries';

export const CXIStartupSummariesTechnology = () => {
    const { t, vars } = useCXIStartup();
    const { startup } = vars;

    const conv = useConversionTable(['yesNo']);
    const data = startup.demographics.techStatus;

    return (
        <>
            <Styled.CXIStartupSummariesTechnology>
                {!!data.institution && (
                    <>
                        <dt>{t('startup.institution')}</dt>
                        <dd>{data.institution}</dd>
                    </>
                )}

                {!!data.hasPatent && (
                    <>
                        <dt>{t('startup.hasPatent')}</dt>
                        <dd>{conv.yesNo[data.hasPatent === 1]}</dd>
                    </>
                )}
            </Styled.CXIStartupSummariesTechnology>

            <Styled.CXIStartupSummariesTechnology>
                {!!data.hasPatent && data.patentWhere && (
                    <>
                        <dt>{t('startup.patentWhere')}</dt>
                        <dd>{data.patentWhere}</dd>
                    </>
                )}

                {!!data.hasPatent && data.patentWho && (
                    <>
                        <dt>{t('startup.patentWho')}</dt>
                        <dd>{data.patentWho}</dd>
                    </>
                )}

                {!!data.hasPatent && data.patentHowMuch && (
                    <>
                        <dt>{t('startup.patentHowMuch')}</dt>
                        <dd>{data.patentHowMuch}</dd>
                    </>
                )}
            </Styled.CXIStartupSummariesTechnology>
        </>
    );
};
